import { render, staticRenderFns } from "./FAssetDetail.vue?vue&type=template&id=7af2eb1a&scoped=true&"
import script from "./FAssetDetail.vue?vue&type=script&lang=js&"
export * from "./FAssetDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af2eb1a",
  null
  
)

export default component.exports